<app-template-number
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [required]="required"
  [regex]="regex"
  [control]="control"
  [commas]="commas"
  [label]="label"
/>
